import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const IconWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.support.green.strong};
  padding: ${({ theme }) => theme.spacing.km4};
  border-radius: ${({ theme }) => theme.border.radius.circle};
  color: ${({ theme }) => theme.color.text.neutral.inverted};
`